import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    pendingAdditions: [],
    pendingEdits: [],
    pendingDeletions: [],
    isSyncing: false
}

const pendingEventsSlice = createSlice({
    name: 'pendingEvents',
    initialState,
    reducers: {
        addPendingEvent: (state, action) => {
            state.pendingAdditions.push(action.payload)
        },
        editPendingEvent: (state, action) => {
            // Remove any existing edit for this event
            state.pendingEdits = state.pendingEdits.filter(e => e.id !== action.payload.id)
            // Add the new edit
            state.pendingEdits.push(action.payload)
        },
        deletePendingEvent: (state, action) => {
            state.pendingDeletions.push(action.payload)
        },
        clearPendingEvents: (state) => {
            state.pendingAdditions = []
            state.pendingEdits = []
            state.pendingDeletions = []
        },
        setSyncingStatus: (state, action) => {
            state.isSyncing = action.payload
        }
    }
})

export const {
    addPendingEvent,
    editPendingEvent,
    deletePendingEvent,
    clearPendingEvents,
    setSyncingStatus
} = pendingEventsSlice.actions

export default pendingEventsSlice.reducer 